import { videoControlsState, bindVideoControls } from './videoControls.js';

/**
 * Shared strategy for autoplaying background videos plus their mute/play
 * controls. Put it on the element that wraps the <video> tag(s) and the
 * `hero-controls` snippet:
 *   x-data="videoWrapper"
 *
 * On top of the mute/play state from videoControls it:
 *   - explicitly kicks playback on init, because iOS Safari ignores the
 *     `autoplay` attribute on videos inserted into the DOM dynamically (e.g.
 *     Alpine x-if templates, as in the product gallery). Muted + playsinline
 *     keeps programmatic play allowed without a user gesture;
 *   - keeps `videoPlaying` in sync with the video's real play/pause events, so
 *     the control icon reflects reality when autoplay is blocked.
 *
 * Used by _hero, _bento-image, _bento-gallery-image and the product gallery.
 */
export default () => ({
  ...videoControlsState(),
  init() {
    bindVideoControls(this);

    this.$nextTick(() => {
      this.$el.querySelectorAll('video').forEach((video) => {
        if (video.offsetParent === null) return;

        // Reflect the real playback state in the controls.
        video.addEventListener('play', () => {
          if (video.offsetParent !== null) this.videoPlaying = true;
        });
        video.addEventListener('pause', () => {
          if (video.offsetParent !== null) this.videoPlaying = false;
        });

        video.muted = this.videoMuted;
        video
          .play()
          .then(() => { this.videoPlaying = true; })
          .catch(() => { this.videoPlaying = false; });
      });
    });
  },
});
